<template>
  <div class="ds-grid">
    <div class="ds-grid__col ds-md-grid__col--offset-2 ds-grid__col--12 ds-md-grid__col--8 ds-margin-bottom-24">
      <DsSelectBox v-if="filterOptions.search" :labels="{
        results: labels.results,
        ariaLabelHint: labels.ariaLabelArrowNavigationHint,
        clearValueButton: labels.clearValueButton,
        submitValueButton: labels.submitValueButton
      }" :placeholder="labels.search" :options="filterOptions.search" :value="query" class="ds-width-full"
        autocomplete @value="handleSearch($event)" />
    </div>
    <!-- Filter: teams -->
    <div
      class="ds-grid__col ds-md-grid__col--offset-2 ds-grid__col--12 ds-md-grid__col--8 ds-lg-grid__col--3 ds-lg-padding-right-0 ds-margin-bottom-12 ds-lg-margin-bottom-0">
      <DsSelectBox v-if="filterOptions.departments" :labels="{
        label: labels.team,
        results: labels.teams,
        ariaLabelHint: labels.ariaLabelArrowNavigationHint,
        clearValueButton: labels.clearValueButton
      }" :icon="{ name: 'team', category: 'team' }" :placeholder="labels.team" :options="filterOptions.departments"
        :value="getFilterValue('team', true)" multiple search class="ds-width-full"
        @value="setFilter('team', $event)" />
    </div>

    <!-- Filter: location -->
    <div
      class="ds-grid__col ds-md-grid__col--offset-2 ds-lg-margin-left-0 ds-grid__col--12 ds-md-grid__col--8 ds-lg-grid__col--3 ds-lg-padding-right-0">
      <DsSelectBox v-if="filterOptions.offices" :labels="{
        label: labels.location,
        results: labels.locations,
        ariaLabelHint: labels.ariaLabelArrowNavigationHint,
        clearValueButton: labels.clearValueButton
      }" :icon="{ name: 'globe', category: 'various' }" :placeholder="labels.location"
        :options="filterOptions.offices" :value="getFilterValue('location')" multiple search class="ds-width-full"
        @value="setFilter('location', $event)" />
    </div>

    <div class="
      ds-grid__col ds-md-grid__col--10 ds-lg-grid__col--2
      ds-margin-top-12 ds-lg-margin-top-0
      ds-lg-margin-left-0
      filters__results
    ">
      <strong>{{ results }}</strong> &nbsp;{{ labels.jobsFound }}
    </div>
  </div>
</template>

<script setup>
import { DsSelectBox } from 'awds'
const { labels } = useGlobalData()
const { jobsData } = useGreenHouse()

// const showFilters = ref(false)
const emit = defineEmits(['search', 'selected'])
const { getFilterValue, filters, normalizeExternalFilterOptions, setFilter, handleSearch, query } = useFilters(emit)

defineProps({
  results: { type: Number, default: 0 }
})

const filterOptions = computed(() => {
  return {
    search: normalizeExternalFilterOptions(jobsData.value?.jobPositions || []),
    departments: normalizeExternalFilterOptions(jobsData.value?.departments || []),
    offices: normalizeExternalFilterOptions(jobsData.value?.offices || [])
  }
})

// Get filter text values instead of ids, used for tracking purpose
// const getFilterTextValues = () => {
//   return filters.value.reduce((acc, item) => {
//     const filterOptions = filterOptions.value[item.name]
//     if (!filterOptions) {
//       return acc
//     }
//     return {
//       ...acc,
//       [item.name]: Array.isArray(item.value)
//         ? item.value.map(i => filterOptions.find(opt => opt.id === i)?.name).join(',')
//         : filterOptions.find(opt => opt.id === item.value)?.name
//     }
//   }, {})
// }
</script>
<style lang="scss" scoped>
.filters {
  &__results {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: flex-end;
    color: black;
  }
}
</style>
